export default "__VITE_ASSET__DuaSxOef__"